import { Remove, Text } from "@components/atoms";
import { Button, Price } from "@components/molecules";

export interface SummaryItemProps {
	id: number;
	label: string;
	amount: number;
	onRemove?: (id: number) => void;
  currency?: string;
	negative?: boolean;
}

export const SummaryItem = ({
	label,
	amount,
	onRemove,
  id,
	currency,
	negative,
}: SummaryItemProps) => {
	return (
		<div className="flex justify-between">
			<Text truncate size="xs" color="mediumGray">
				{label}
			</Text>
			<div className="flex items-center gap-1">
				<Price
					size="xs"
					color="mediumGray"
					currency={currency}
					price={amount}
					negative={negative}
					data-testid={`${id}-item-amount`}
				/>
				{onRemove && (
					<Button
						aria-label="Remove Discount"
						iconButton
						size="md"
						variant="tertiaryNew"
						onClick={() => onRemove?.(id)}
						data-testid={`${id}-remove-discount`}
					>
						<Remove />
					</Button>
				)}
			</div>
		</div>
	);
};